export const phrase = "szukaj";